/*
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-13 22:08:53
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-14 14:40:46
 * @FilePath: \demo\src\store.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'


Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    // krpanos: 
  },
  mutations: {
    getKrpano(state, newValue) {
      state.krpanos = newValue // 用于更新全局变量的mutation
    }
  },
  plugins: [vuexLocal.plugin]
})